import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import MgeBrowse from '@/components/MgeBrowse'
import ClusterBrowse from '@/components/ClusterBrowse'
import Projcets from '@/components/Projects'
import Samples from '@/components/Samples'
import PcAnn from '@/components/PcAnn'
import ViewProtCluster from '@/components/ViewProtCluster'
import Interactions from '@/components/Interactions'
import ViewCluster from '@/components/ViewCluster'
import ViewMge from '@/components/ViewMge'
import ViewProject from '@/components/ViewProject'
import ViewSample from '@/components/ViewSample'
import NBlastRequest from '@/components/NBlastRequest'
import BlastResults from '@/components/BlastResults'
import Help from '@/components/Help'
Vue.use(Router)

let router = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            meta:{
                title:'Home:MMGE database'
            },
            component: Home
        },
        {
            path: '/mgebrowse',
            name: 'MgeBrowser',
            meta:{
                title:'Browser MGEs:MMGE database'
            },
            component: MgeBrowse,
        },
        {
            path: '/clusterbrowse',
            name: 'ClusterBrowse',
            meta:{
                title:'Browse MGE clusters:MMGE database'
            },
            component: ClusterBrowse,
        },
        {
            path: '/projectsbrowse',
            name: 'Projcets',
            meta:{
                title:'Browse projects:MMGE database'
            },
            component: Projcets,
        },
        {
            path: '/network',
            name: 'Network',
            meta:{
                title:'Browse Host Interactions:MMGE database'
            },
            component: Interactions,
        },
        {
            path: '/samplesbrowse',
            name: 'Samples',
            meta:{
                title:'Browse projects:MMGE database'
            },
            component: Samples,
        },
        {
            path: '/submitBlast',
            name: 'nBlast',
            meta:{
                title:'BLAST search:MMGE database'
            },
            component: NBlastRequest,
        },
        {
            path: '/blastResults',
            name: 'nBlastResults',
            meta:{
                title:'BLAST results:MMGE database'
            },
            component: BlastResults,
            children:[
                {
                    meta:{
                        title:'BLAST results:MMGE database'
                    },
                    path: '/blastResults/:blastId',
                    name: 'nBlastResults/:blastId',
                    component: BlastResults,
                },
            ]
        },
        {
            path: '/pcann',
            name: 'PcAnn',
            meta:{
                title:'Browse proteins Annotation:MMGE database'
            },
            component: PcAnn,
            children:[
                {
                    meta:{
                        title:'Browse proteins Annotation:MMGE database'
                    },  
                    path: '/pcann/:pcid',
                    name: 'PcAnn/:pcid',
                    component: PcAnn,
                },
            ]
        },
        {
            path: '/viewproject/:projid',
            name: 'ViewProject/:projid',
            meta:{
                title:'Project details:MMGE database'
            },
            component: ViewProject,
        },
        {
            path: '/viewsample/:samid',
            name: 'ViewSample/:samid',
            meta:{
                title:'Sample details:MMGE database'
            },
            component: ViewSample,
        },
        {
            path: '/viewcluster/:clustid',
            name: 'ViewCluster/:clustid',
            meta:{
                title:'eMGE Cluster details:MMGE database'
            },
            component: ViewCluster,
        },
        {
            path: '/viewprotcluster/:clustid',
            name: 'ViewProtcluster/:clustid',
            meta:{
                title:'Protein Cluster details:MMGE database'
            },
            component: ViewProtCluster,
        },
        {
            path: '/viewmge/:mgeid',
            name: 'ViewMge/:mgeid',
            meta:{
                title:'eMGE details:MMGE database'
            },
            component: ViewMge,
        },
        {
            path: '/help',
            name: 'Help',
            meta:{
                title:'Help page:MMGE database'
            },
            component: Help,
        },
    ]
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    next()
})

export default router
